import React, { useEffect, useState } from 'react'

const About = () => {

    useEffect(() => {
        document.title = 'AmanChauhan-About'
    })

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loader = document.getElementById("preloader");

        const handleLoad = () => {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
            if (loader) {
                loader.style.display = "none";
            }
        };

        const isMobile = window.innerWidth <= 840;

        if (isMobile) {
            handleLoad();  // Directly call handleLoad for mobile devices
        } else if (document.readyState === 'complete') {
            // If the document is already loaded, call handleLoad immediately
            handleLoad();
        } else {
            window.addEventListener("load", handleLoad);
        }

        return () => {
            window.removeEventListener("load", handleLoad);
        };
    }, []); // Empty dependency array means this effect runs once on component mount


    return (
        <>
            {loading ? (
                <div id="preloader" className='preloader'>
                    <img src="../IMG/Aman.png" className='preload-img' alt="AMAN CHAUHAN" />
                    <h2 className='preload-heading'>AMAN CHAUHAN</h2>
                </div>
            ) :
                <>
                    <section id="Me-new">
                        <div className="Profile-About-Container">
                            <div className='About-Img' data-aos="zoom-out-down" data-aos-duration="1000"></div>
                            <div className='About-Img-Txt' data-aos="zoom-out-up" data-aos-duration="1000">"You here? Want to know more about me, hmm? Well, hold onto your hat!"</div>
                            <a href='#More-About-Me' data-aos="zoom-out-up" data-aos-duration="1000"><img src="../IMG/Down.gif" alt="Down GIF" ></img></a>
                        </div>
                    </section>

                    <section id="More-About-Me">
                        <div className="MyExpertise">
                            <h3 data-aos="slide-up" data-aos-duration="1000">Know more about my expertise.</h3>
                            <div className="FirstContainer">
                                <div className="FirstContainer-img-container" data-aos="fade-right" data-aos-duration="1000">
                                    <img src="./IMG/About/About-img.jpg" className='FirstContainer-img' alt="About-img" />
                                </div>
                                <div className="FirstContainer-p-container">
                                    <div className="p-container-item" data-aos="fade-up" data-aos-duration="1000">
                                        <p className="container-item-heading">Full-Stack Innovator</p>
                                        <p className="container-item-para">Seamlessly blending frontend and backend skills, I create dynamic websites and apps with user-centric design. Leveraging the power of ML/AI, I enhance web applications with intelligent features, ensuring a responsive and adaptive online experience.</p>
                                    </div>
                                    <div className="p-container-item margin-top" data-aos="fade-up" data-aos-duration="1000">
                                        <p className="container-item-heading">AI-Powered Developer</p>
                                        <p className="container-item-para">As an AI-Powered Developer, I specialize in web and app development, integrating machine learning to elevate functionality. Trusted to enhance online presence, my focus on intelligent design ensures a superior and innovative digital environment for organizations.</p>
                                    </div>
                                    <div className="p-container-item margin-top" data-aos="fade-up" data-aos-duration="1000">
                                        <p className="container-item-heading">Intelligent Solutions Engineer</p>
                                        <p className="container-item-para">An Intelligent Solutions Engineer adept at merging frontend and backend development, I prioritize intelligent features powered by ML/AI. My comprehensive approach ensures every project benefits from cutting-edge technology, offering innovation and smart solutions in equal measure.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="Expectations">
                            <h3 data-aos="slide-up" data-aos-duration="1000">What you can also expect from me.</h3>
                            <div className="SecondContainer">
                                <div className="card-container">
                                    <div className="card-item" data-aos={`${window.innerWidth >= 820 ? 'fade-right' : 'fade-up'}`} data-aos-duration="1000">
                                        <p className="card-heading">Collaboration</p>
                                        <p className="card-para">Collaborate seamlessly on projects, leveraging my full-stack skills and security expertise. Together, we'll elevate ideas into innovative, secure digital realities.</p>
                                    </div>
                                    <div className="card-item" data-aos="slide-up" data-aos-duration="1000">
                                        <p className="card-heading">Innovative Solutions</p>
                                        <p className="card-para">Expect cutting-edge tech fused with user-centric design, ensuring standout digital experiences that resonate in the online landscape.</p>
                                    </div>
                                    <div className="card-item" data-aos={`${window.innerWidth >= 820 ? 'fade-left' : 'fade-up'}`} data-aos-duration="1000">
                                        <p className="card-heading">Security Beyond Standards</p>
                                        <p className="card-para">Proactively identify vulnerabilities, offering security measures surpassing industry standards for fortified digital assets and trust in digital safety.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="MyLife">
                            <h3 data-aos="slide-up" data-aos-duration="1000">When I’m not working, I’m doing something else.</h3>
                            <div className="ThirdContainer">
                                <div className="PhotoContainer" data-aos="zoom-out-up" data-aos-duration="1000">
                                    <div className="photo-item">
                                        <img src="./IMG/About/ME.jpeg" className='photo-img' alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section id='About-footer'>
                        <div className="footer--content">
                            <div className="Footer--info new-info">
                                <p data-aos="slide-up" data-aos-duration="1000">You can also find me on social media:</p>
                                <div className="Footer--links new-links">
                                    <a href="https://www.linkedin.com/in/aman-chauhan-779955256/" target='__blank' data-aos="fade-right" data-aos-duration="1000">Linkedin</a>
                                    <a href="https://www.instagram.com/_.ig_aman/" target='__blank' data-aos="fade-right" data-aos-duration="1000">Instagram</a>
                                </div>
                            </div>
                            <div className="Footer--Moreinfo new-Moreinfo">
                                <p data-aos="fade-up" data-aos-duration="1000">If you want to find out more about me check the page below:</p>
                                <button className="Moreinfo-btn2" data-aos="fade-up" data-aos-duration="1000"><a href="/">Get in Touch</a></button>
                            </div>
                        </div>
                        <div className="footer--Copyright new-Copyright">
                            Copyright &#169; 2023 Aman Chauhan. All rights reserved.
                        </div>
                    </section>

                </>

            }

        </>
    )
}

export default About